import { twJoin } from 'tailwind-merge';

import { ManoClubDarkLLogo } from '@/domains/core/tamagoshiTailwind/logos/manoClub/ManoClubDarkLLogo';
import { useAuth } from '@/domains/customerManagement/auth/hooks/useAuth';
import { useLoyaltyProgramActivated } from '@/domains/loyalty/modules/LoyaltyProgram/hooks/useLoyaltyProgramActivated.default';
import { LoyaltyLevelLabelWrapper } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyLevelLabel/LoyaltyLevelLabelWrapper';
import { LoyaltyProgramCardContent } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/LoyaltyProgramCardContent';
import { LoyaltyProgramCardUnauthenticatedContent } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/LoyaltyProgramCardUnauthenticatedContent';

import styles from './LoyaltyProgramCard.module.scss';

interface Props {
  fullHeight?: boolean;
}

export const LoyaltyProgramCard = ({ fullHeight }: Props) => {
  const { isOptOutLoyaltyProgramV2 } = useLoyaltyProgramActivated();
  const { isAuthenticated } = useAuth();

  if (isOptOutLoyaltyProgramV2) {
    return null;
  }

  return (
    <div
      className={twJoin(
        fullHeight ? 'h-full' : 'h-[150px]',
        `w-full max-w-[330px] rounded-container bg-loyalty-tertiary p-m
        text-foundation-primary`,
        styles.card,
      )}
    >
      <div className="flex h-full flex-col justify-between">
        <div className="flex justify-between">
          <ManoClubDarkLLogo className="h-[20px]" />
          {!!isAuthenticated && <LoyaltyLevelLabelWrapper />}
        </div>
        {isAuthenticated ? (
          <LoyaltyProgramCardContent />
        ) : (
          <LoyaltyProgramCardUnauthenticatedContent />
        )}
      </div>
    </div>
  );
};

LoyaltyProgramCard.displayName = 'LoyaltyProgramCard';
